(function () {
  'use strict';

  var MAX_FILE_BYTES = 25 * 1024 * 1024;
  var NETWORK_EVENT = 'inkmerge:uploader-network';
  var FIELD_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  function installNetworkObserver() {
    if (window.__imUploadFetchObserved || typeof window.fetch !== 'function') return;

    var originalFetch = window.fetch.bind(window);
    window.__imUploadFetchObserved = true;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var requestInit = init;
      var phase = /\/a\/upload-center\/register(?:\?|$)/.test(url)
        ? 'register'
        : (/\/a\/upload-center\/cartline(?:\?|$)/.test(url) ? 'cartline' : '');

      if (phase === 'register' && requestInit && typeof requestInit.body === 'string') {
        try {
          var registerBody = JSON.parse(requestInit.body);
          var registerSize = Number(registerBody.fileSize);
          var registerFieldId = String(registerBody.fieldId || '').trim();
          var invalidField = !FIELD_ID_PATTERN.test(registerFieldId);
          var oversizedFile = Number.isFinite(registerSize) && registerSize > MAX_FILE_BYTES;

          if (invalidField || oversizedFile) {
            var blockedStatus = invalidField ? 422 : 413;
            document.dispatchEvent(new CustomEvent(NETWORK_EVENT, {
              detail: { phase: phase, state: 'error', status: blockedStatus }
            }));
            return Promise.resolve(new Response(JSON.stringify({
              error: invalidField ? 'Uploader field is not configured.' : 'File exceeds the 25MB upload limit.'
            }), {
              status: blockedStatus,
              headers: { 'Content-Type': 'application/json' }
            }));
          }
        } catch (error) {}
      }

      if (phase === 'cartline' && requestInit && typeof requestInit.body === 'string') {
        try {
          var body = JSON.parse(requestInit.body);
          var variantInput = document.querySelector('[data-imupload-variant]');
          var quantityInput = document.querySelector('[data-imupload-quantity]');
          var currentQuantity = parseInt(quantityInput ? quantityInput.value : body.quantity, 10);
          if (variantInput && variantInput.value) body.variantId = String(variantInput.value);
          body.quantity = Number.isFinite(currentQuantity) && currentQuantity > 0 ? currentQuantity : 1;
          requestInit = Object.assign({}, requestInit, { body: JSON.stringify(body) });
        } catch (error) {}
      }

      if (phase) {
        document.dispatchEvent(new CustomEvent(NETWORK_EVENT, {
          detail: { phase: phase, state: 'busy' }
        }));
      }

      return originalFetch(input, requestInit).then(function (response) {
        if (phase) {
          document.dispatchEvent(new CustomEvent(NETWORK_EVENT, {
            detail: { phase: phase, state: response.ok ? 'complete' : 'error', status: response.status }
          }));
        }
        return response;
      }, function (error) {
        if (phase) {
          document.dispatchEvent(new CustomEvent(NETWORK_EVENT, {
            detail: { phase: phase, state: 'error', status: 0 }
          }));
        }
        throw error;
      });
    };
  }

  function boot(root) {
    var isBySize = root.getAttribute('data-by-size') === 'true';
    var variantsNode = root.querySelector('[data-imupload-variants]');
    var variantInput = root.querySelector('[data-imupload-variant]');
    var price = root.querySelector('[data-imupload-price]');
    var atc = root.querySelector('[data-imupload-atc]');
    var status = root.querySelector('[data-imupload-status]');
    var quantity = root.querySelector('[data-imupload-quantity]');
    var form = root.querySelector('[data-imupload-form]');
    var appRoot = root.querySelector('.im-upload');
    var appStatus = appRoot ? appRoot.querySelector('[data-status]') : null;
    var configAlert = root.querySelector('[data-imupload-config-alert]');
    var fieldId = appRoot ? (appRoot.getAttribute('data-field-id') || '').trim() : '';
    var uploaderMissing = !appRoot || !fieldId || !!root.querySelector('.imupload__app-missing');
    var networkBusy = false;
    var syncPending = false;
    var submitting = false;
    var hydratingProperties = false;
    var selectedVariant = null;
    var variants = [];

    try { variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]'); } catch (error) { variants = []; }

    if (form) form.setAttribute('data-uploader-ready', uploaderMissing ? 'false' : 'true');

    function money(cents) {
      try {
        var currency = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function setAppStatus(message, state) {
      if (!appStatus && appRoot) appStatus = appRoot.querySelector('[data-status]');
      if (!appStatus) return;
      appStatus.textContent = message || '';
      if (state) appStatus.setAttribute('data-state', state);
      else appStatus.removeAttribute('data-state');
    }

    function selectedValue(index) {
      var selected = root.querySelector('[data-imupload-option][data-option-index="' + index + '"][aria-checked="true"]');
      return selected ? selected.getAttribute('data-option-value') : null;
    }

    function appState() {
      if (!appStatus && appRoot) appStatus = appRoot.querySelector('[data-status]');
      return appStatus ? (appStatus.getAttribute('data-state') || '') : '';
    }

    function hasReadyArtwork() {
      return !!appRoot && appState() === 'success' && !!appRoot.querySelector('.filepond--item');
    }

    function syncStickyPurchaseState(label, disabled, ariaLabel) {
      var stickyButton = document.querySelector('[data-inkmerge-sticky-atc-btn]');
      var stickyVariant = document.querySelector('[data-inkmerge-sticky-variant]');
      var stickyPrice = document.querySelector('[data-inkmerge-sticky-price]');
      if (stickyVariant && selectedVariant && selectedVariant.title && selectedVariant.title !== 'Default Title') {
        stickyVariant.textContent = selectedVariant.title;
      }
      if (stickyPrice && price && price.textContent) stickyPrice.textContent = price.textContent;
      if (!stickyButton) return;
      stickyButton.disabled = disabled;
      stickyButton.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      stickyButton.setAttribute('aria-label', ariaLabel || label);
      stickyButton.classList.toggle('is-imupload-disabled', disabled);
      stickyButton.textContent = label;
    }

    function setPurchaseState(mainLabel, disabled, stickyLabel, stickyAriaLabel) {
      atc.disabled = disabled;
      atc.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      atc.textContent = mainLabel;
      syncStickyPurchaseState(stickyLabel || mainLabel, disabled, stickyAriaLabel || mainLabel);
    }

    function syncPurchaseState() {
      if (!atc) return;

      if (uploaderMissing) {
        setPurchaseState('Artwork uploader unavailable', true, 'Upload unavailable', 'Artwork uploader unavailable');
        return;
      }

      if (!selectedVariant || !selectedVariant.available) {
        setPurchaseState(selectedVariant ? 'Unavailable' : 'Combination unavailable', true);
        return;
      }

      if (submitting) {
        setPurchaseState('Adding transfer...', true, 'Adding...');
        return;
      }

      if (networkBusy || syncPending || appState() === 'busy') {
        setPurchaseState('Finishing artwork upload...', true, 'Finishing upload');
        return;
      }

      if (!hasReadyArtwork()) {
        setPurchaseState('Upload artwork to continue', true, 'Upload artwork');
        return;
      }

      setPurchaseState(
        isBySize ? 'Add configured transfer to cart' : 'Add uploaded gang sheet to cart',
        false,
        'Add to cart'
      );
    }

    function updateVariant() {
      if (!isBySize) {
        selectedVariant = variants.find(function (variant) {
          return String(variant.id) === String(variantInput ? variantInput.value : '');
        }) || variants[0] || null;
        syncPurchaseState();
        return;
      }

      selectedVariant = variants.find(function (variant) {
        for (var index = 1; index <= 3; index += 1) {
          var value = selectedValue(index);
          if (value && variant['option' + index] !== value) return false;
        }
        return true;
      }) || null;

      if (!selectedVariant) {
        if (variantInput) {
          variantInput.value = '';
          variantInput.setAttribute('value', '');
        }
        setStatus('Choose another listed size.');
        syncPurchaseState();
        return;
      }

      if (variantInput) {
        if (hasReadyArtwork()) syncPending = true;
        variantInput.value = selectedVariant.id;
        variantInput.setAttribute('value', String(selectedVariant.id));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) price.textContent = money(selectedVariant.price);
      setStatus(selectedVariant.available ? '' : 'This size is currently unavailable.');

      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariant.id);
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      syncPurchaseState();
    }

    function revealUnavailableState() {
      if (form) form.setAttribute('data-uploader-ready', 'false');
      root.classList.add('is-uploader-unavailable');
      if (appRoot) appRoot.classList.add('is-unavailable');
      if (configAlert) configAlert.hidden = false;
      setStatus('This item was not added to the cart.');
      syncPurchaseState();
    }

    function revealConfiguredState() {
      if (form) form.setAttribute('data-uploader-ready', 'true');
      root.classList.remove('is-uploader-unavailable');
      if (appRoot) appRoot.classList.remove('is-unavailable');
      if (configAlert) configAlert.hidden = true;
    }

    function protectFileInputs() {
      if (!appRoot) return;
      appRoot.querySelectorAll('.im-upload__trust li').forEach(function (item) {
        if (item.textContent.trim().toLowerCase() === 'available to download from your account anytime') {
          item.remove();
        }
      });
      appRoot.querySelectorAll('input[type="file"]').forEach(function (input) {
        if (uploaderMissing) {
          input.disabled = true;
          input.setAttribute('aria-disabled', 'true');
        }
      });
      var sizeRule = appRoot.querySelector('[data-rules-size]');
      if (sizeRule && sizeRule.textContent !== 'Up to 25MB') sizeRule.textContent = 'Up to 25MB';
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-imupload-option]');
      if (!option) return;
      var index = option.getAttribute('data-option-index');
      root.querySelectorAll('[data-imupload-option][data-option-index="' + index + '"]').forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-checked', 'false');
      });
      option.classList.add('is-active');
      option.setAttribute('aria-checked', 'true');
      updateVariant();
    });

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('.im-upload input[type="file"]')) return;
      var file = input.files && input.files[0];

      if (uploaderMissing) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.value = '';
        revealUnavailableState();
        return;
      }

      if (file && file.size > MAX_FILE_BYTES) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.value = '';
        setAppStatus('File is larger than the 25MB upload limit.', 'error');
        setStatus('Choose a file that is 25MB or smaller.');
        syncPurchaseState();
      }
    }, true);

    if (quantity) {
      quantity.addEventListener('change', function () {
        var value = parseInt(quantity.value, 10);
        quantity.value = Number.isFinite(value) && value > 0 ? value : 1;
        quantity.setAttribute('value', quantity.value);

        if (hasReadyArtwork() && variantInput) {
          syncPending = true;
          var currentVariantValue = variantInput.value;
          variantInput.setAttribute('value', currentVariantValue + ' ');
          variantInput.setAttribute('value', currentVariantValue);
          syncPurchaseState();
        }
      });
    }

    document.addEventListener(NETWORK_EVENT, function (event) {
      var detail = event.detail || {};
      if (detail.state === 'busy') {
        networkBusy = true;
      } else {
        networkBusy = false;
        if (detail.phase === 'cartline') syncPending = false;
        if (detail.state === 'error') {
          setStatus('Artwork could not be finalized. This item was not added to the cart.');
        }
      }
      syncPurchaseState();
    });

    if (appRoot) {
      new MutationObserver(function () {
        protectFileInputs();
        syncPurchaseState();
      }).observe(appRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-state']
      });
    }

    function propertyValue(name) {
      var input = form ? form.querySelector('input[name="properties[' + name + ']"]') : null;
      return input ? input.value : '';
    }

    function addPropertiesFromUploader() {
      var synthetic = new Event('submit', { bubbles: false, cancelable: true });
      synthetic.preventDefault();
      hydratingProperties = true;
      form.dispatchEvent(synthetic);
      hydratingProperties = false;
    }

    async function readCart() {
      var response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('cart readback failed (' + response.status + ')');
      return response.json();
    }

    async function rollbackLine(lineKey, quantityBefore) {
      if (!lineKey) return false;
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: quantityBefore })
      });
      if (!response.ok) return false;
      var cart = await response.json();
      var remaining = cart.items.find(function (item) { return item.key === lineKey; });
      return quantityBefore === 0 ? !remaining : !!remaining && remaining.quantity === quantityBefore;
    }

    async function submitConfiguredItem() {
      if (uploaderMissing) {
        revealUnavailableState();
        return;
      }
      if (networkBusy || syncPending || appState() === 'busy') {
        setStatus('Wait for the artwork upload to finish before adding this transfer.');
        syncPurchaseState();
        return;
      }
      if (!hasReadyArtwork()) {
        setAppStatus('Please upload a design before adding to cart.', 'warn');
        setStatus('Upload one artwork file to continue.');
        appRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        syncPurchaseState();
        return;
      }

      addPropertiesFromUploader();
      var uploadUrl = propertyValue('View uploads');
      var uploadToken = propertyValue('__ucToken');
      var uploadExpiry = propertyValue('__ucExp');
      if (!uploadUrl || !uploadToken || !uploadExpiry) {
        setStatus('Artwork verification is incomplete. This item was not added to the cart.');
        syncPurchaseState();
        return;
      }

      submitting = true;
      syncPurchaseState();
      setStatus('Adding the verified transfer to your cart...');

      var cartBefore = await readCart();
      var requestedQuantity = parseInt(quantity ? quantity.value : '1', 10);
      requestedQuantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
      var formData = new FormData(form);
      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: formData
      });

      if (!addResponse.ok) {
        throw new Error('add to cart failed (' + addResponse.status + ')');
      }

      var added = await addResponse.json();
      if (Array.isArray(added.items)) added = added.items[0];
      var cartAfter = await readCart();
      var line = cartAfter.items.find(function (item) {
        return added && added.key ? item.key === added.key : false;
      }) || cartAfter.items.find(function (item) {
        return String(item.id) === String(variantInput ? variantInput.value : '') &&
          item.properties && item.properties.__ucToken === uploadToken;
      });
      var properties = line && line.properties ? line.properties : {};
      var beforeLine = line ? cartBefore.items.find(function (item) { return item.key === line.key; }) : null;
      var expectedQuantity = (beforeLine ? beforeLine.quantity : 0) + requestedQuantity;
      var verified = !!line &&
        String(line.id) === String(variantInput ? variantInput.value : '') &&
        Number(line.quantity) === expectedQuantity &&
        properties.__ucToken === uploadToken &&
        properties['View uploads'] === uploadUrl;

      if (!verified) {
        var lineKey = line ? line.key : (added ? added.key : '');
        var rolledBack = await rollbackLine(lineKey, beforeLine ? beforeLine.quantity : 0);
        setStatus(rolledBack
          ? 'Artwork details could not be verified. The cart change was rolled back.'
          : 'Artwork details could not be verified. Review your cart before continuing.');
        throw new Error(rolledBack ? 'cart verification failed; rolled back' : 'cart verification and rollback failed');
      }

      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          var result = Shopify.analytics.publish('inkmerge:custom_transfer_add_to_cart_verified', {
            productId: root.getAttribute('data-product-id') || '',
            variantId: variantInput ? variantInput.value : '',
            workflow: isBySize ? 'by_size' : 'gang_sheet_upload'
          });
          if (result && typeof result.catch === 'function') result.catch(function () {});
        }
      } catch (error) {}

      window.location.assign('/cart');
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (hydratingProperties) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (submitting) return;

        submitConfiguredItem().catch(function (error) {
          console.error('[inkmerge] configured transfer submit failed', error);
          submitting = false;
          syncPurchaseState();
          if (!status || !status.textContent) {
            setStatus('This transfer was not added. Review the artwork and try again.');
          }
        });
      }, true);
    }

    protectFileInputs();
    if (uploaderMissing) revealUnavailableState();
    else revealConfiguredState();
    updateVariant();
  }

  function init() {
    installNetworkObserver();
    document.querySelectorAll('[data-imupload]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
